import React, { useState } from "react";
import makeStyles from '@mui/styles/makeStyles';
import {
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Button,
  Card,
  CardHeader,
  CardContent,
  FormHelperText,
} from "@mui/material";

import { useTranslation } from "react-i18next";

//get DispensingLanguage

const MenuEntryFormData = ({
  errorObject,
  addProductForm,
  formData,
  handleChange,
  handleCheck,
  handleReset,
  handleSubmit,
  handleUpdate,
  ...props
}) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "menu-entry";
  const ParentMenu = JSON.parse(localStorage.getItem("ParentMenu"));

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3">
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading text-center">
              <div className="sw_heading_title_inner">
                {DispensingLanguage[lan][menukey]["Menu Entry - Add/Edit"]}
              </div>
            </div>
          </Grid>
        </div>

        {/* New row */}
        <Grid container spacing={3}>
          {/* New row */}
          <Grid item xs={12} sm={12}>
            <Card className="sw_card">
              <CardHeader
                title={DispensingLanguage[lan][menukey]["Menu Entry Form"]}
              />
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    <Grid container spacing={4}>
                      <Grid item xs={12} sm={3}>
                        <TextField variant="standard"
                          disabled={!!props.permissionType}
                          error={!!errorObject.title}
                          helperText={errorObject.title}
                          required
                          id="title"
                          name="title"
                          label={DispensingLanguage[lan][menukey]["Menu Name"]}
                          value={formData.title}
                          fullWidth
                          autoComplete="family-name"
                          // inputProps={{ maxLength: 4 }}
                          onChange={(e) => handleChange(e)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <TextField variant="standard"
                          error={!!errorObject.url}
                          helperText={errorObject.url}
                          required
                          id="url"
                          name="url"
                          label={DispensingLanguage[lan][menukey]["Menu Url"]}
                          value={formData.url}
                          fullWidth
                          autoComplete="family-name"
                          disabled={!addProductForm}
                          inputProps={{ maxLength: 150 }}
                          onChange={(e) => handleChange(e)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <FormControl variant="standard" fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            {DispensingLanguage[lan][menukey]["Menu Position"]}
                          </InputLabel>
                          <Select
                            disabled={!!props.permissionType}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            name="position"
                            value={formData.position}
                            fullWidth
                            onChange={(e) => handleChange(e)}
                          label={DispensingLanguage[lan][menukey]["Menu Position"]}>
                            <MenuItem value={"left_position"}>
                              Left Position
                            </MenuItem>
                            <MenuItem value={"right_position"}>
                              Right Position
                            </MenuItem>
                          </Select>
                          {/* <FormHelperText error={!!errorObject.position}>
                          {errorObject.position}
                        </FormHelperText> */}
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <FormControl variant="standard" fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            {DispensingLanguage[lan][menukey]["Menu MenuLevel"]}
                          </InputLabel>
                          <Select
                            disabled={!!props.permissionType}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            name="MenuLevel"
                            value={formData.MenuLevel}
                            fullWidth
                            onChange={(e) => handleChange(e)}
                          label={DispensingLanguage[lan][menukey]["Menu MenuLevel"]}>
                            <MenuItem value={"menu_level_1"}>
                              Menu Level 1
                            </MenuItem>
                            <MenuItem value={"menu_level_2"}>
                              Menu Level 2
                            </MenuItem>
                            <MenuItem value={"menu_level_3"}>
                              Menu Level 3
                            </MenuItem>
                          </Select>
                          {/* <FormHelperText error={!!errorObject.MenuLevel}>
                          {errorObject.MenuLevel}
                        </FormHelperText> */}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <FormControl variant="standard" className={classes.fullWidth}>
                          <InputLabel id="demo-simple-select-helper-label">
                            {DispensingLanguage[lan][menukey]["Parent menu"]}
                          </InputLabel>
                          <Select
                            disabled={!!props.permissionType}
                            //error={!!errorObject.parentId}
                            labelId="demo-simple-select-helper-label"
                            id="demo-simple-select-helper"
                            name="parentId"
                            value={formData.parentId}
                            fullWidth
                            onChange={(e) => handleChange(e)}
                          label={DispensingLanguage[lan][menukey]["Parent menu"]}>
                            {ParentMenu.map((item, index) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                              );
                            })}
                          </Select>
                          {/* <FormHelperText error={!!errorObject.parentId}>
                          {errorObject.parentId}
                        </FormHelperText> */}
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Action buttons */}
          {addProductForm ? (
            <Grid item xs={12} className="mt-4 text-center">
              <Button
                disabled={!!props.permissionType}
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => handleReset()}
              >
                {DispensingLanguage[lan][menukey]["Reset"]}
              </Button>
              <Button
                disabled={!!props.permissionType}
                className="me-2"
                variant="contained"
                color="primary"
                onClick={() => handleSubmit()}
              >
                {DispensingLanguage[lan][menukey]["Save"]}
              </Button>
              <Button
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => props.history.push("/menu-entry")}
              >
                {DispensingLanguage[lan][menukey]["Cancel"]}
              </Button>
            </Grid>
          ) : (
            <Grid item xs={12} className="mt-2 text-center">
              <Button
                disabled={!!props.permissionType}
                className="me-2"
                variant="contained"
                color="primary"
                onClick={() => handleUpdate()}
              >
                {DispensingLanguage[lan][menukey]["update"]}
              </Button>
              <Button
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => props.history.push("/menu-entry")}
              >
                {DispensingLanguage[lan][menukey]["Cancel"]}
              </Button>
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default MenuEntryFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
